
// FIX: Replaced incorrect component implementation with actual type definitions.
export enum RolUsuario {
    Administrador = 'administrador',
    Cliente = 'cliente',
    ClienteEmpresa = 'cliente_empresa',
}
export enum Moneda {
    // Latin America
    ARS = 'ARS', // Peso Argentino
    USD = 'USD', // Dólar Estadounidense
    BRL = 'BRL', // Real Brasileño
    CLP = 'CLP', // Peso Chileno
    UYU = 'UYU', // Peso Uruguayo
    MXN = 'MXN', // Peso Mexicano
    COP = 'COP', // Peso Colombiano
    PEN = 'PEN', // Sol Peruano
    PYG = 'PYG', // Guaraní Paraguayo
    BOB = 'BOB', // Boliviano
    VES = 'VES', // Bolívar Venezolano
    // Europe
    EUR = 'EUR', // Euro
    GBP = 'GBP', // Libra Esterlina
    CHF = 'CHF', // Franco Suizo
    // North America
    CAD = 'CAD', // Dólar Canadiense
    // Asia
    JPY = 'JPY', // Yen Japonés
    CNY = 'CNY', // Yuan Chino
    INR = 'INR', // Rupia India
    KRW = 'KRW', // Won Surcoreano
    // Oceania
    AUD = 'AUD', // Dólar Australiano
    NZD = 'NZD', // Dólar Neozelandés
}


export enum EstadoAviso {
    Pendiente = 'pendiente',
    Aprobado = 'aprobado',
    Rechazado = 'rechazado',
    Expirado = 'expirado',
    Suspendido = 'suspendido',
    Borrado = 'borrado',
    Borrador = 'borrador',
}

export enum EstadoPago {
    Completado = 'completado',
    Pendiente = 'pendiente',
    Fallido = 'fallido',
}

export enum MetodoPago {
    MercadoPago = 'mercado_pago',
    Modo = 'modo',
    Payway = 'payway',
    QR = 'qr',
    Paypal = 'paypal',
    Transferencia = 'transferencia',
    Efectivo = 'efectivo',
    Crypto = 'crypto',
}

export enum AccionHistorial {
    Creacion = 'creacion',
    Aprobacion = 'aprobacion',
    Rechazo = 'rechazo',
    EdicionContenido = 'edicion_contenido',
    EdicionImagenes = 'edicion_imagenes',
    Suspension = 'suspension',
    Reanudacion = 'reanudacion',
    Borrado = 'borrado',
}

export enum Combustible {
    Nafta = 'nafta',
    Gasoil = 'gas oil',
    GNC = 'gnc',
    GLP = 'glp',
}

export enum OperacionInmueble {
    Alquiler = 'alquiler',
    Temporario = 'temporario',
    Venta = 'venta',
    Compra = 'compra',
    Permuta = 'permuta',
}

export enum VendedorInmueble {
    Propietario = 'propietario',
    Empresa = 'empresa',
    Inmobiliaria = 'inmobiliaria',
    Corredor = 'corredor',
}

export enum OperacionVehiculo {
    Venta = 'venta',
    Alquiler = 'alquiler',
    Compra = 'compra',
    Permuta = 'permuta',
}

export enum FormaPago {
    Contado = 'Contado',
    Transferencias = 'Transferencias',
    Cheques = 'Cheques',
    AConvenir = 'A convenir',
}

export type ViewName = 'dashboard' | 'gdac' | 'planes' | 'clientes' | 'categorias' | 'clienteDetalle' | 'avisoDetalle' | 'avisosClasificados' | 'misAvisos' | 'misFavoritos';

export interface View {
    name: ViewName;
    id?: number;
}

export interface Notification {
    id_notificacion: number;
    id_usuario: number;
    tipo: 'mensaje' | 'pago' | 'aviso' | 'sistema' | 'alerta';
    titulo: string;
    mensaje: string;
    leida: boolean;
    link?: string;
    metadata?: {
        id_aviso?: number;
        id_pago?: number;
        id_mensaje?: number;
        id_conversacion?: number;
        [key: string]: any;
    };
    fecha_creacion: string;
}

export interface ChatMessage {
    role: 'user' | 'model';
    text: string;
    sources?: any[]; // For grounding sources
}

export interface Usuario {
    id_usuario: number;
    nombre: string;
    email: string;
    telefono: string;
    whatsapp?: string;
    direccion?: string;
    provincia?: string;
    pais?: string; // Global country context
    rol: RolUsuario;
    fecha_registro: string; // ISO date string
    verificado: boolean;
    habilita_tienda?: boolean; // Only for cliente_empresa
    id_plan_tienda?: number; // Selected store plan for cliente_empresa
    fecha_acepta_legal?: string; // ISO date string when user accepted legal notice
    advertencias?: number;
    bloqueado?: boolean;
    cuit?: string;
    razon_social?: string;
    phone_verified_at?: string; // ISO date string when WhatsApp was verified
    email_verified_at?: string; // ISO date string when email was verified
}

export interface Categoria {
    id_categoria: number;
    nombre: string;
    nombre_en?: string;
    nombre_pt?: string;
    estado: 'activo' | 'inactivo';
    id_padre: number | null;
}

export interface Plan {
    id_plan: number;
    nombre: string;
    nombre_en?: string;
    nombre_pt?: string;
    descripcion: string;
    descripcion_en?: string;
    descripcion_pt?: string;
    precio: number;
    precio_usd: number;
    duracion_dias: number;
    max_imagenes: number;
    prioridad: number;
    resaltado: boolean;
    recurrente?: boolean; // For auto-renewal subscriptions
    estado: 'activo' | 'inactivo';
}

export interface Aviso {
    id_aviso: number;
    titulo: string;
    precio: number;
    id_categoria: number;
    id_subcategoria: number | null;
    id_categoria_tienda?: number | null; // For stores using custom catalog
    id_usuario: number;
    id_plan: number;
    estado: EstadoAviso;
    fecha_creacion: string; // ISO date string
    fecha_expiracion: string; // ISO date string
    ubicacion: string;
    vistas: number;
    departamento?: string; // Department/partido within province (e.g., Rawson, Capital)
    provincia?: string; // Added province field
    pais?: string; // Added country field for optimization
    moneda?: Moneda;
    imagenes: string[];
    imagenes_thumbnails?: string[]; // Thumbnail versions for fast card view rendering
    pagado: boolean;
    subtitulo?: string;
    descripcion_detallada?: string;
    id_tienda?: number; // Added to support correct Cart functionality (linked to Store)

    // Vehicle specific fields
    operacion_vehiculo?: OperacionVehiculo;
    forma_pago?: FormaPago;
    version?: string;
    combustible?: Combustible;
    anio?: number;
    km?: number;
    comentario?: string;
    transmision?: string;
    color?: string;
    cantidad_puertas?: number | string;

    // Inmueble specific fields
    operacion_inmueble?: OperacionInmueble;
    vendedor_inmueble?: VendedorInmueble;
    zona_inmueble?: string;
    barrio_privado_inmueble?: boolean;
    superficie_total?: number;
    superficie_cubierta?: number;
    ambientes?: number;
    dormitorios?: number;
    banos?: number;
    cocheras?: number;

    // General
    descripcion?: string;

    // Derived/Enriched fields (Frontend only)
    whatsapp_cliente?: string;
    nombre_cliente?: string;
    nombre_categoria?: string;
    nombre_subcategoria?: string;
    nombre_plan?: string;
    rol_usuario?: string;
    // User info aliases
    nombre_usuario?: string;
    telefono_usuario?: string;
    whatsapp_usuario?: string;
    prioridad?: number;
    resaltado?: boolean;
    nombre_tienda?: string; // Enriched: Store Name
    tienda_slug?: string;   // Enriched: Store Slug for linking

    // Destacado (Premium) fields
    destacado?: boolean;
    fecha_fin_destacado?: string;
    monto_destacado?: number;

    // Urgente fields
    urgente?: boolean;
    fecha_fin_urgente?: string;
    monto_urgente?: number;

    // Fraud Detection fields
    analisis_fraude?: any; // FraudAnalysis object
    puntuacion_fraude?: number;
    requiere_revision_fraude?: boolean;

    // Auto-renewal fields
    auto_renovar?: boolean;

    // Inventory
    stock?: number;

    // Variants
    variantes?: ProductoVariante[];

    // Price Lists
    precio_mayorista?: number;
}

export interface ProductoVariante {
    id_variante: number;
    id_aviso: number;
    nombre: string;
    stock: number;
    precio: number | null; // Si es null, usa el precio base del aviso
    precio_mayorista?: number | null;
    activo: boolean;
}


export interface Pago {
    id_pago: number;
    id_usuario: number;
    id_plan: number;
    id_aviso?: number; // Optional, linking payment to specific ad
    monto: number;
    moneda?: string;
    fecha_pago: string; // ISO date string
    estado: EstadoPago;
    metodo_pago: MetodoPago;
    datos_pago?: any; // To store MP response
}

export interface HistorialAviso {
    id_historial: number;
    id_aviso: number;
    id_usuario_accion: number;
    accion: AccionHistorial;
    detalles: string | null;
    fecha_accion: string; // ISO date string
}

// ==================== STORE CATEGORY TYPES ====================

export interface CategoriaTienda {
    id_categoria_tienda: number;
    id_tienda: number;
    nombre: string;
    descripcion?: string;
    id_padre: number | null; // For hierarchical categories
    orden: number; // Display order
    activa: boolean;
    fecha_creacion: string;
}

// ==================== E-COMMERCE TYPES ====================

export interface Tienda {
    id_tienda: number;
    id_usuario: number;
    nombre_tienda: string;
    descripcion: string;
    logo_url?: string;
    banner_url?: string;
    slug: string;
    privada?: boolean;
    usar_catalogo_propio?: boolean; // Toggle: use custom store catalog vs CRM global catalog
    activa: boolean;
    configuracion: TiendaConfiguracion;
    fecha_creacion: string;
    fecha_actualizacion: string;
    // Plan fields
    id_plan_tienda?: number;
    fecha_vencimiento_plan?: string;
    plan_activo?: boolean;
    id_plan_solicitado?: number; // New field for pending plan change requests
    nombre_plan?: string; // Enriched field (join)
    nombre_plan_solicitado?: string; // Enriched field (join)
    email_corporativo_solicitado?: boolean; // New field for corporate email requests
    email_corporativo?: string; // New field for assigned corporate email
}

export interface TiendaConfiguracion {
    modulos: {
        carrito_compras: boolean;
        checkout: boolean;
        pagos_online: boolean;
        delivery: boolean;
        gestion_stock: boolean;
    };
    pagos: {
        mercadopago?: {
            enabled: boolean;
            public_key: string;
            access_token: string;
        };
        transferencia?: {
            enabled: boolean;
            datos_bancarios: string;
        };
        crypto?: {
            enabled: boolean;
            wallet_address: string;
            network: string;
            instructions?: string;
        };
    };
    delivery: {
        metodos: string[];
        costo_envio_base: number;
        envio_gratis_desde: number;
        notas?: string;
    };
    apariencia: {
        color_primario: string;
        color_secundario: string;
        tema: 'light' | 'dark';
    };
    // Configuración de contacto
    contacto?: {
        email_tienda: string;
        email_notificaciones: boolean;
        telefono_tienda?: string;
    };
    // Configuración de WhatsApp Business
    whatsapp?: {
        enabled: boolean;
        numero: string;
        mensaje_bienvenida?: string;
        notificar_pedidos: boolean;
        notificar_pagos: boolean;
        boton_flotante: boolean;
    };
    // Configuración de Afiliados
    afiliados?: {
        enabled: boolean;
        porcentaje: number;
    };
}

export interface Pedido {
    id_pedido: number;
    id_tienda: number;
    id_cliente: number;
    numero_pedido: string;
    items: PedidoItem[];
    subtotal: number;
    costo_envio: number;
    descuento: number;
    total: number;
    estado: EstadoPedido;
    metodo_pago?: string;
    metodo_envio?: string;
    direccion_envio?: DireccionEnvio;
    datos_pago?: any; // MercadoPago payment data
    notas_cliente?: string;
    notas_tienda?: string;
    fecha_pedido: string;
    fecha_actualizacion: string;
    // Enriched data
    tienda?: Partial<Tienda>;
    cliente?: Partial<Usuario>;
}

export interface PedidoItem {
    id_aviso: number; // Reference to aviso (product)
    titulo: string;
    precio: number;
    cantidad: number;
    subtotal: number;
    imagen?: string;
    id_variante?: number;
    nombre_variante?: string;
}

export interface DireccionEnvio {
    nombre_completo: string;
    telefono: string;
    calle: string;
    numero: string;
    piso_depto?: string;
    ciudad: string;
    provincia: string;
    codigo_postal: string;
}

export interface CarritoCompras {
    id_carrito: number;
    id_usuario?: number;
    id_tienda: number;
    session_id?: string;
    items: CarritoItem[];
    fecha_creacion: string;
    fecha_actualizacion: string;
}

export interface CarritoItem {
    id_aviso: number;
    titulo: string;
    precio: number;
    moneda: Moneda;
    cantidad: number;
    stock_disponible: number;
    imagen?: string;
    // Variants
    id_variante?: number;
    nombre_variante?: string;
}

export enum EstadoPedido {
    Pendiente = 'pendiente',
    Confirmado = 'confirmado',
    Preparando = 'preparando',
    Enviado = 'enviado',
    Entregado = 'entregado',
    Cancelado = 'cancelado'
}

// ==================== STORE PLANS TYPES ====================

export interface PlanTienda {
    id_plan_tienda: number;
    nombre: string;
    nombre_en?: string;
    nombre_pt?: string;
    descripcion: string;
    descripcion_en?: string;
    descripcion_pt?: string;
    precio: number;
    precio_usd: number;
    duracion_dias: number;
    // Límites de contenido
    max_avisos: number;
    max_productos: number;
    max_categorias: number;
    max_imagenes_por_aviso: number;
    max_imagenes_por_producto: number;
    // Características
    permite_pagos_online: boolean;
    permite_delivery: boolean;
    permite_whatsapp: boolean;
    soporte_prioritario: boolean;
    permite_diseno_ia: boolean;
    permite_logo_ia: boolean;
    // Control
    prioridad: number;
    destacado: boolean;
    recurrente?: boolean;
    estado: 'activo' | 'inactivo';
    fecha_creacion: string;
}

export interface PagoTienda {
    id_pago_tienda: number;
    id_tienda: number;
    id_plan_tienda: number;
    monto: number;
    moneda: string;
    fecha_pago: string;
    fecha_vencimiento: string;
    estado: EstadoPago;
    metodo_pago: string;
    datos_pago?: any;
    notas?: string;
}

export interface Calificacion {
    id_calificacion: number;
    id_usuario_calificador: number;
    id_usuario_calificado: number;
    puntuacion: number; // 1-5
    motivo: string;
    fecha: string;
    usuario_calificador?: { nombre: string; };
}

// ==================== SEARCH ALERTS TYPES ====================

export type FrecuenciaAlerta = 'inmediata' | 'diaria' | 'semanal';

export interface AlertaBusqueda {
    id_alerta: number;
    id_usuario: number;
    nombre_alerta: string;
    termino_busqueda?: string;
    id_categoria?: number;
    id_subcategoria?: number;
    precio_min?: number;
    precio_max?: number;
    provincia?: string;
    ubicacion?: string;
    activa: boolean;
    notificar_email: boolean;
    frecuencia: FrecuenciaAlerta;
    ultimo_check?: string;
    avisos_notificados: number[];
    fecha_creacion: string;
    fecha_actualizacion: string;
    // Enriched fields
    nombre_categoria?: string;
    nombre_subcategoria?: string;
    matches_count?: number;
}

// ==================== CHAT TYPES ====================

export type TipoMensaje = 'texto' | 'imagen' | 'oferta';
export type EstadoConversacion = 'activa' | 'archivada' | 'bloqueada';

export interface Conversacion {
    id_conversacion: number;
    id_aviso?: number;
    id_comprador: number;
    id_vendedor: number;
    ultimo_mensaje?: string;
    ultimo_mensaje_preview?: string;
    unread_comprador: number;
    unread_vendedor: number;
    estado: EstadoConversacion;
    fecha_creacion: string;
    // Enriched fields
    aviso?: {
        titulo: string;
        imagenes?: string[];
        precio?: number;
    };
    comprador?: {
        nombre: string;
        id_usuario: number;
    };
    vendedor?: {
        nombre: string;
        id_usuario: number;
    };
}

export interface Mensaje {
    id_mensaje: number;
    id_conversacion: number;
    id_remitente: number;
    contenido: string;
    tipo: TipoMensaje;
    leido: boolean;
    fecha: string;
    // Enriched
    remitente?: {
        nombre: string;
    };
}

// ==================== CUPONES TYPES ====================

export type TipoDescuento = 'porcentaje' | 'monto_fijo';
export type AplicaCupon = 'todos' | 'destacados' | 'urgentes' | 'planes' | 'tienda';

export interface Cupon {
    id_cupon: number;
    codigo: string;
    descripcion?: string;
    tipo_descuento: TipoDescuento;
    valor_descuento: number;
    descuento_maximo?: number;
    monto_minimo?: number;
    usos_maximos?: number;
    usos_actuales: number;
    usos_por_usuario: number;
    aplica_a: AplicaCupon;
    id_tienda?: number;
    fecha_inicio?: string;
    fecha_fin?: string;
    activo: boolean;
    solo_primera_compra: boolean;
    fecha_creacion: string;
}

export interface CuponUso {
    id_uso: number;
    id_cupon: number;
    id_usuario: number;
    monto_descuento: number;
    id_pedido?: number;
    id_pago_destacado?: number;
    id_pago_urgente?: number;
    fecha_uso: string;
}

export interface ValidacionCupon {
    valido: boolean;
    mensaje: string;
    descuento: number;
    id_cupon?: number;
}

// ==================== AFFILIATE SYSTEM TYPES ====================

export interface Afiliado {
    id_afiliado: number;
    id_usuario: number;
    codigo_referido: string;
    saldo_actual: number;
    saldo_historico: number;
    estado: 'activo' | 'suspendido';
    porcentaje_comision: number;
    fecha_creacion: string;
}

export interface Referencia {
    id_referencia: number;
    id_afiliado: number;
    id_usuario_referido: number;
    origen?: string;
    fecha_registro: string;
    // Enriched
    usuario_referido?: {
        nombre: string;
        email: string; // Maybe mask this for privacy?
    };
}

export interface Comision {
    id_comision: number;
    id_afiliado: number;
    id_pago: number;
    monto_comision: number;
    porcentaje_aplicado: number;
    estado: 'pendiente' | 'aprobada' | 'anulada';
    fecha_creacion: string;
    // Enriched
    pago?: {
        monto: number;
        fecha_pago: string;
    };
}


export interface SolicitudRetiro {
    id_retiro: number;
    id_afiliado: number;
    monto: number;
    metodo_pago: string;
    datos_pago?: string;
    estado: 'pendiente' | 'procesando' | 'pagado' | 'rechazado';
    comprobante_url?: string;
    fecha_solicitud: string;
    fecha_proceso?: string;
}

// Banners
export type BannerPosition = 'home_top' | 'home_middle' | 'list_sidebar' | 'detail_sidebar';

export interface Banner {
    id_banner: number;
    titulo: string;
    imagen_url: string;
    link_destino?: string;
    posicion: BannerPosition;
    fecha_inicio: string;
    fecha_fin?: string;
    activo: boolean;
    contador_vistas: number;
    contador_clicks: number;
    orden: number;
    fecha_creacion: string;
}
